module.exports = __webpack_public_path__ + "img/img-25.f8964354.png";